import React, { memo, useMemo } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./styles.scss";

const SummaryCard = ({
  value = "",
  description,
  imageURl = "",
  isMobileView = false,
  tooltipText = "",
  asteriskTooltip = "",
}) => {
  // Responsive class for 1024px screens only
  const is1024 = useMemo(
    () =>
      typeof window !== "undefined" &&
      window.matchMedia &&
      window.matchMedia("(max-width: 1024px)").matches,
    []
  );

  const imageStyles = {
    marginRight: isMobileView ? "12px" : is1024 ? "10px" : "24px",
  };

  const cardContainerStyles = is1024
    ? undefined
    : {
        display: "flex",
        alignItems: "center",
        padding: isMobileView ? "12px" : "24px",
        backgroundColor: "white",
        height: "100%",
      };

  const numberStyles = is1024
    ? undefined
    : {
        fontSize: isMobileView ? "18px" : "24px",
        fontWeight: 400,
        lineHeight: "32px",
        color: "#1D2026",
      };

  const descStyles = is1024
    ? undefined
    : {
        fontSize: isMobileView ? "12px" : "14px",
        fontWeight: 400,
        lineHeight: "22px",
        color: "#4E5566",
        letterSpacing: "-0.01em",
      };

  const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);

    let timeString = "";
    if (hrs > 0) timeString += `${hrs}h `;
    if (mins > 0 || hrs > 0) timeString += `${mins}m `;

    return timeString.trim();
  };

  // Determine if the value represents time (if the description contains "Time")
  const formattedValue =
    description.toLowerCase().includes("time") && typeof value === "number"
      ? formatTime(value)
      : value;

  return (
    <div
      className={is1024 ? "summary-card-1024" : undefined}
      style={cardContainerStyles}
    >
      <div style={imageStyles}>
        <img src={imageURl} alt="icon-img" />
      </div>
      <div style={{ flex: 1 }}>
        <div
          className={is1024 ? "summary-card-number-1024" : undefined}
          style={numberStyles}
        >
          {formattedValue ? formattedValue : 0}
        </div>
        <div
          className={is1024 ? "summary-card-desc-1024" : undefined}
          style={descStyles}
        >
          {description}
          {asteriskTooltip && (
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id={`tooltip-asterisk-${description.replace(/\s+/g, "-")}`}>
                  {asteriskTooltip}
                </Tooltip>
              }
            >
              <span
                style={{
                  color: "#ff6b6b",
                  marginLeft: "4px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "bold",
                }}
              >
                *
              </span>
            </OverlayTrigger>
          )}
        </div>
      </div>
      {tooltipText && (
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id={`tooltip-${description.replace(/\s+/g, "-")}`}>
              {tooltipText}
            </Tooltip>
          }
        >
          <div
            style={{
              marginLeft: "8px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
            }}
          >
            <i
              className="fa fa-info-circle"
              style={{
                fontSize: "16px",
                color: "#6c757d",
              }}
            ></i>
          </div>
        </OverlayTrigger>
      )}
    </div>
  );
};

export default memo(SummaryCard);
